import React from "react";
import {
  FaUsers,
  FaBoxes,
  FaHistory,
  FaSignOutAlt,
  FaBars,
  FaTimes,
  FaChartPie,
} from "react-icons/fa";
import { Link, useNavigate } from "react-router-dom";
import Mughallogo from "../assets/Mughallogo.jfif";

export default function Sidebar({ onLogout, isOpen, toggleSidebar }) {
  const navigate = useNavigate();

  const handleLogout = () => {
    localStorage.removeItem("mughalsLoggedIn");
    onLogout();
    navigate("/login");
  };

  return (
    <>
      {/* Topbar for small screens */}
      <div
        className="d-flex 
        justify-content-between d-lg-none align-items-center px-3 py-2 bg-white 
         position-fixed w-100"
        style={{ top: 0, zIndex: 999 }}
      >
        <img
          src={Mughallogo}
          alt="Mughal Logo"
          className="rounded-circle"
          style={{ width: "50px", height: "50px", objectFit: "cover" }}
        />
        <button
          className="btn btn-link fs-3 text-dark"
          onClick={toggleSidebar}
          aria-label="Toggle Sidebar"
        >
          {isOpen ? <FaTimes /> : <FaBars />}
        </button>
      </div>

      {/* Sidebar */}
      <aside className={`sidebar shadow-lg ${isOpen ? "sidebar-open " : ""}`}>
        <div className="sidebar-header text-center mt-2">
          <img
            src={Mughallogo}
            alt="Mughal Logo"
            style={{
              width: "130px",
              height: "120px",
              borderRadius: "50%",
              objectFit: "cover",
              border: "2px solid #87d007",
              padding: "1px",
            }}
          />
        </div>

        <nav className="sidebar-nav mt-4">
          <ul className="list-unstyled ps-3">
            <li className="mb-3">
              <Link to="/Home">
                <FaChartPie className="icon me-2" />
                <span>Dashboard</span>
              </Link>
            </li>
            <li className="mb-3">
              <Link to="/history">
                <FaHistory className="icon me-2" />
                <span>Delivery Orders</span>
              </Link>
            </li>
            <li className="mb-3">
              <Link to="/assignmaterial">
                <FaUsers className="icon me-2" />
                <span>Give Material</span>
              </Link>
            </li>
            <li className="mb-3">
              <Link to="/Material">
                <FaBoxes className="icon me-2" />
                <span>Material</span>
              </Link>
            </li>
            <li className="mb-3">
              <Link to="/Customer">
                <FaUsers className="icon me-2" />
                <span>Customers</span>
              </Link>
            </li>
            <li className="mb-3">
              <Link to="/AddCustomer">
                <FaUsers className="icon me-2" />
                <span>Add Customer</span>
              </Link>
            </li>
          </ul>
        </nav>

        <div className="text-center mt-auto pb-5 w-100">
          <button className="btn bg-custom w-75 h-100" onClick={handleLogout}>
            <FaSignOutAlt className="icon me-2" />
            Logout
          </button>
        </div>
      </aside>
    </>
  );
}
